// @flow
import React, { Component, Fragment } from 'react';
import { type ContextRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import ScrollToTop from 'components/common/ScrollToTop';
import CategoryProductCards from 'containers/list/CategoryProductCards';
import CategoriesTemplate from 'components/categories/CategoriesTemplate';
import CategoryItemListContainer from 'containers/categories/CategoryItemListContainer';
import CategoryCurrentContainer from 'containers/categories/CategoryCurrentContainer';
import CategorySectionListContainer from 'containers/categories/CategorySectionListContainer';

type Props = {} & ContextRouter;

class Categories extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort, supplier } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <CategoriesTemplate>
        {category ? (
          <Helmet>
            <title>{`${category} | 캐시바이`}</title>
            <meta
              name="description"
              content={`캐시바이에 등록된 ${category} 카테고리에 포함한 상품들을 모아보세요.`}
            />
          </Helmet>
        ) : (
          <Helmet>
            <title>카테고리 | 캐시바이</title>
            <meta
              name="description"
              content="캐시바이에 등록된 다양한 컨텐츠을 카테고리별 분류해서 살펴보세요."
            />
          </Helmet>
        )}
        {category ? (
          <Fragment>
            <CategoryCurrentContainer category={category} />
            <CategoryProductCards category={category} sort={sort} supplier={supplier} />
          </Fragment>
        ) : (
          <Fragment>
            <CategorySectionListContainer />
            <CategoryItemListContainer sort={sort} supplier={supplier} />
          </Fragment>
        )}
      </CategoriesTemplate>
    );
  }
}

export default Categories;



// WEBPACK FOOTER //
// ./src/pages/Categories.js